var echarts_color = [
  "#3c90f7",
  "#55bfc0",
  "#5ebe67",
  "#f4cd49",
  "#e05667",
  "#2ec7c9",
  "#ffb980",
  "#5ab1ef",
  "#b6a2de",
  "#d87a80",
  "#8d98b3",
  "#e5cf0d",
  "#97b552",
  "#95706d",
  "#dc69aa",
  "#07a2a4",
  "#9a7fd1",
  "#588dd5",
  "#f5994e",
  "#c05050",
  "#59678c",
  "#c9ab00",
  "#7eb00a",
  "#6f5553",
  "#c14089"
];

export default echarts_color;



// WEBPACK FOOTER //
// ./src/assest/utils/echarts_color.js